module.exports = __webpack_public_path__ + "static/media/wager.b12c0a90.svg";